export const welcomeEmailTranslations = {
  en: {
    greeting: "Welcome to {title}, and thanks for subscribing!",
    description:
      "New posts will show up in your inbox from now on. You can also log in to manage your subscription, or even create your own publication.\n\nOne last thing...\n\nIf you don't see the newsletter, check Spam or Promotions and move this email to your main inbox so future posts land where they should.",
    subjectPlaceholder: "Welcome to {title}!",
  },
  ca: {
    greeting: "benvingut a {title}, i gràcies per subscriure-t'hi!",
    description:
      "A partir d'ara, les noves publicacions apareixeran a la teva safata d'entrada. També pots iniciar sessió per gestionar la teva subscripció o fins i tot crear la teva pròpia publicació.\n\nUna última cosa...\n\nSi no veus el butlletí, revisa la carpeta de Spam o Promocions i mou aquest correu a la teva safata principal perquè les futures publicacions arribin on han d'arribar.",
    subjectPlaceholder: "benvingut a {title}!",
  },
  es: {
    greeting: "¡bienvenido a {title}, y gracias por suscribirte!",
    description:
      "A partir de ahora, las nuevas publicaciones aparecerán en tu bandeja de entrada. También puedes iniciar sesión para gestionar tu suscripción o incluso crear tu propia publicación.\n\nUna última cosa...\n\nSi no ves el boletín, revisa la carpeta de Spam o Promociones y mueve este correo a tu bandeja principal para que las futuras publicaciones lleguen donde deben.",
    subjectPlaceholder: "¡bienvenido a {title}!",
  },
  fr: {
    greeting: "bienvenue sur {title}, et merci de vous être abonné !",
    description:
      "À partir de maintenant, les nouveaux articles apparaîtront dans votre boîte de réception. Vous pouvez également vous connecter pour gérer votre abonnement ou même créer votre propre publication.\n\nUne dernière chose...\n\nSi vous ne voyez pas la newsletter, vérifiez le dossier Spam ou Promotions et déplacez cet e-mail vers votre boîte de réception principale afin que les futurs articles arrivent où ils doivent.",
    subjectPlaceholder: "bienvenue sur {title} !",
  },
  de: {
    greeting: "willkommen bei {title}, und danke fürs abonnieren!",
    description:
      "Ab sofort erscheinen neue Beiträge in deinem Posteingang. Du kannst dich auch anmelden, um dein Abonnement zu verwalten oder sogar deine eigene Veröffentlichung zu erstellen.\n\nEine letzte Sache...\n\nWenn du den Newsletter nicht siehst, überprüfe den Spam- oder Werbeordner und verschiebe diese E-Mail in deinen Hauptposteingang, damit zukünftige Beiträge dort ankommen, wo sie sollen.",
    subjectPlaceholder: "willkommen bei {title}!",
  },
  it: {
    greeting: "benvenuto su {title}, e grazie per esserti iscritto!",
    description:
      "Da ora in poi, i nuovi articoli appariranno nella tua casella di posta. Puoi anche accedere per gestire il tuo abbonamento o persino creare la tua pubblicazione.\n\nUn'ultima cosa...\n\nSe non vedi la newsletter, controlla la cartella Spam o Promozioni e sposta questa email nella tua casella principale in modo che i futuri articoli arrivino dove dovrebbero.",
    subjectPlaceholder: "benvenuto su {title}!",
  },
  pt: {
    greeting: "bem-vindo ao {title}, e obrigado por se inscrever!",
    description:
      "A partir de agora, novas publicações aparecerão na sua caixa de entrada. Você também pode fazer login para gerenciar sua assinatura ou até mesmo criar sua própria publicação.\n\nUma última coisa...\n\nSe você não vir o boletim, verifique a pasta de Spam ou Promoções e mova este e-mail para sua caixa de entrada principal para que as futuras publicações cheguem onde devem.",
    subjectPlaceholder: "bem-vindo ao {title}!",
  },
} as const

export type WelcomeEmailLocale = keyof typeof welcomeEmailTranslations

export function getWelcomeEmailTranslations(locale: string) {
  const key = locale as WelcomeEmailLocale
  return welcomeEmailTranslations[key] ?? welcomeEmailTranslations.en
}

export function getDefaultWelcomeEmailContent(locale: string, title: string) {
  const translations = getWelcomeEmailTranslations(locale)
  return {
    type: "doc",
    content: [
      {
        type: "heading",
        attrs: { level: 3 },
        content: [
          { type: "text", text: translations.greeting.replace("{title}", title) },
        ],
      },
      ...translations.description
        .split("\n\n")
        .filter(p => p.trim())
        .map(text => ({
          type: "paragraph",
          content: [{ type: "text", text: text.trim() }],
        })),
    ],
  }
}

export function getDefaultWelcomeEmailSubject(locale: string, title: string) {
  const translations = getWelcomeEmailTranslations(locale)
  return translations.subjectPlaceholder.replace("{title}", title)
}
